import { TrashCan } from "@carbon/icons-react";
import { type FC } from "react";

import { Banner } from "@moment/design-system/Banner";

import { usePageActor } from "~/state";

import { useEasel } from "../../easel";

export const PageArchivedBanner: FC = () => {
	const { documentId, pageId } = useEasel();
	const pageActor = usePageActor(documentId, pageId);

	const unarchivePage = () => {
		pageActor?.send({
			type: "page.unarchived",
		});
	};

	return (
		<Banner
			variant="negative"
			level="primary"
			icon={<TrashCan />}
			message="This page has been archived."
			actionText="Restore this page"
			actionOnClick={() => {
				unarchivePage();
			}}
			shouldShowAction
		/>
	);
};
